/**
 * Magnetic Button Effect
 * Creates a magnetic pull effect on buttons and interactive elements
 */

class MagneticButtons {
  constructor() {
    this.buttons = document.querySelectorAll('[data-magnetic]');
    this.init();
  }
  
  init() {
    // Skip on touch devices
    if ('ontouchstart' in window) return;
    
    this.buttons.forEach((button) => {
      button.addEventListener('mousemove', (e) => this.onMouseMove(e, button));
      button.addEventListener('mouseleave', (e) => this.onMouseLeave(e, button));
    });
  }
  
  onMouseMove(e, button) {
    const rect = button.getBoundingClientRect();
    const x = e.clientX - rect.left - rect.width / 2;
    const y = e.clientY - rect.top - rect.height / 2;
    
    const strength = 0.3;
    
    button.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
  }
  
  onMouseLeave(e, button) {
    button.style.transform = 'translate(0, 0)';
    button.style.transition = 'transform 0.3s ease';
    
    setTimeout(() => {
      button.style.transition = '';
    }, 300);
  }
}

export default MagneticButtons;
